import useZohoMcpUnlocker from '../Components/ZohoId/useZohoMcpUnlocker'
import { useDispatch, useSelector } from 'react-redux'
import { selectClientConfig, selectCurrentContractActive } from './SubscriptionFormSelectors'
import { addContractErrors, removeErrorFromContract } from './SubscriptionFormSlice'
import { useTranslation } from 'react-i18next'

const useFormStatus = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { errors, config } = useSelector(selectCurrentContractActive)
  const {
    isEditable = true,
    resendAllowed = true,
    contractLastSaveValidate: lastSentDate = null,
    hasAlreadyVotedFeedback = false,
  } = config || {}
  const { contractLoaded, isValidZohoId } = useSelector(selectClientConfig)
  const { blockedForAgent } = useZohoMcpUnlocker()
  const addErrorToContract = (id, field) => {
    dispatch(addContractErrors({ data: field, id }))
  }
  const removeContractError = (id, field) => {
    dispatch(removeErrorFromContract({ data: field, id }))
  }

  const testFieldValidity = (field, value, validations, contractId) => {
    if (!validations || !validations[field]) {
      return
    }
    const isValid = validations[field](null, false, value)
    if (!isValid) {
      addErrorToContract(contractId, {
        [field]:
          t(`subscriptionForm:validation_errors_v2.${field}`) ??
          `Field ${field} is missing in validation list translations`,
      })
    } else {
      removeContractError(contractId, field)
    }
  }

  return {
    formIsLoaded: contractLoaded === true,
    isEditable,
    hasAlreadyVotedFeedback,
    lastSentDate,
    errors,
    zohoIsInValid: !isValidZohoId || blockedForAgent,
    resendAllowed,
    addErrorToContract,
    testFieldValidity,
  }
}

export default useFormStatus
